import { render, staticRenderFns } from "./PodSelector.vue?vue&type=template&id=18af346a&scoped=true"
import script from "./PodSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./PodSelector.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PodSelector.vue?vue&type=style&index=0&id=18af346a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18af346a",
  null
  
)

export default component.exports